// src/chainId.ts
var ChainId = /* @__PURE__ */ ((ChainId3) => {
  ChainId3[ChainId3["ETHEREUM"] = 1] = "ETHEREUM";
  ChainId3[ChainId3["GOERLI"] = 5] = "GOERLI";
  ChainId3[ChainId3["BSC"] = 56] = "BSC";
  ChainId3[ChainId3["BSC_TESTNET"] = 97] = "BSC_TESTNET";
  ChainId3[ChainId3["ZKSYNC_TESTNET"] = 280] = "ZKSYNC_TESTNET";
  ChainId3[ChainId3["ZKSYNC"] = 324] = "ZKSYNC";
  ChainId3[ChainId3["OPBNB_TESTNET"] = 5611] = "OPBNB_TESTNET";
  ChainId3[ChainId3["OPBNB"] = 204] = "OPBNB";
  ChainId3[ChainId3["POLYGON_ZKEVM"] = 1101] = "POLYGON_ZKEVM";
  ChainId3[ChainId3["POLYGON_ZKEVM_TESTNET"] = 1442] = "POLYGON_ZKEVM_TESTNET";
  ChainId3[ChainId3["ARBITRUM_ONE"] = 42161] = "ARBITRUM_ONE";
  ChainId3[ChainId3["ARBITRUM_GOERLI"] = 421613] = "ARBITRUM_GOERLI";
  ChainId3[ChainId3["ARBITRUM_SEPOLIA"] = 421614] = "ARBITRUM_SEPOLIA";
  ChainId3[ChainId3["SCROLL_SEPOLIA"] = 534351] = "SCROLL_SEPOLIA";
  ChainId3[ChainId3["LINEA"] = 59144] = "LINEA";
  ChainId3[ChainId3["LINEA_TESTNET"] = 59140] = "LINEA_TESTNET";
  ChainId3[ChainId3["ZEUSCHAIN"] = 34504] = "ZEUSCHAIN";
  ChainId3[ChainId3["APECHAIN"] = 33139] = "APECHAIN";
  ChainId3[ChainId3["APOLLO"] = 62606] = "APOLLO";
  ChainId3[ChainId3["BASE"] = 8453] = "BASE";
  ChainId3[ChainId3["POLYGON"] = 137] = "POLYGON";
  ChainId3[ChainId3["BASE_TESTNET"] = 84531] = "BASE_TESTNET";
  ChainId3[ChainId3["BASE_SEPOLIA"] = 84532] = "BASE_SEPOLIA";
  ChainId3[ChainId3["SEPOLIA"] = 11155111] = "SEPOLIA";
  return ChainId3;
})(ChainId || {});
var testnetChainIds = [
  5 /* GOERLI */,
  97 /* BSC_TESTNET */,
  280 /* ZKSYNC_TESTNET */,
  5611 /* OPBNB_TESTNET */,
  1442 /* POLYGON_ZKEVM_TESTNET */,
  421613 /* ARBITRUM_GOERLI */,
  534351 /* SCROLL_SEPOLIA */,
  59140 /* LINEA_TESTNET */,
  84531 /* BASE_TESTNET */,
  11155111 /* SEPOLIA */,
  421614 /* ARBITRUM_SEPOLIA */,
  84532 /* BASE_SEPOLIA */
];

// src/zeusChain.ts
var zeusChain = {
  id: 34504,
  network: "zeuschain",
  name: "ZeusChain",
  nativeCurrency: {
    name: "Zeus",
    symbol: "ZEUS",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.zeuschainscan.io"]
    },
    public: {
      http: ["https://mainnet-rpc.zeuschainscan.io"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Zeusscan",
      url: "https://zeuschainscan.io"
    },
    default: {
      name: "Zeusscan",
      url: "https://zeuschainscan.io"
    },
    etherscan: {
      name: "Zeusscan",
      url: "https://zeuschainscan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x"
    },
    ensUniversalResolver: {
      address: "0x",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0x614f8698661bB8c933E022E8474dd220A5994161",
      blockCreated: 1974040
    }
  }
};

// src/apeChain.ts
var apeChain = {
  id: 33139,
  network: "apechain",
  name: "ApeChain",
  nativeCurrency: {
    name: "Ape",
    symbol: "APE",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://apechain.calderachain.xyz/http"]
    },
    public: {
      http: ["https://apechain.calderachain.xyz/http", "https://rpc.apechain.com"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "ApeScan",
      url: "https://apescan.io",
      apiURL: "https://api.apescan.io/api"
    },
    default: {
      name: "ApeScan",
      url: "https://apescan.io"
    },
    etherscan: {
      name: "ApeScan",
      url: "https://apescan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x"
    },
    ensUniversalResolver: {
      address: "0x",
      blockCreated: 0
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 20889
    }
  }
};

// src/apolloChain.ts
var apolloChain = {
  id: 62606,
  network: "apollochain",
  name: "ApolloChain",
  nativeCurrency: {
    name: "Apollo",
    symbol: "APOLLO",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet-rpc.apolloscan.io"]
    },
    public: {
      http: ["https://mainnet-rpc.apolloscan.io"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "ApolloScan",
      url: "https://apolloscan.io"
    },
    default: {
      name: "ApolloScan",
      url: "https://apolloscan.io"
    },
    etherscan: {
      name: "ApolloScan",
      url: "https://apolloscan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x"
    },
    ensUniversalResolver: {
      address: "0x",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xa2cC48e31Ea87B7a9320BD5F26F20cf79d8D92dA",
      blockCreated: 507195
    }
  }
};

// src/chainNames.ts
var chainNames = {
  [1 /* ETHEREUM */]: "eth",
  [5 /* GOERLI */]: "goerli",
  [56 /* BSC */]: "bsc",
  [97 /* BSC_TESTNET */]: "bscTestnet",
  [42161 /* ARBITRUM_ONE */]: "arb",
  [421613 /* ARBITRUM_GOERLI */]: "arbGoerli",
  [1101 /* POLYGON_ZKEVM */]: "polygonZkEVM",
  [1442 /* POLYGON_ZKEVM_TESTNET */]: "polygonZkEVMTestnet",
  [324 /* ZKSYNC */]: "zkSync",
  [280 /* ZKSYNC_TESTNET */]: "zkSyncTestnet",
  [59144 /* LINEA */]: "linea",
  [59140 /* LINEA_TESTNET */]: "lineaTestnet",
  [204 /* OPBNB */]: "opBNB",
  [5611 /* OPBNB_TESTNET */]: "opBnbTestnet",
  [34504 /* ZEUSCHAIN */]: "zeus",
  [33139 /* APECHAIN */]: "ape",
  [62606 /* APOLLO */]: "apollo",
  [8453 /* BASE */]: "base",
  [137 /* POLYGON */]: "polygon",
  [84531 /* BASE_TESTNET */]: "baseTestnet",
  [534351 /* SCROLL_SEPOLIA */]: "scrollSepolia",
  [11155111 /* SEPOLIA */]: "sepolia",
  [421614 /* ARBITRUM_SEPOLIA */]: "arbSepolia",
  [84532 /* BASE_SEPOLIA */]: "baseSepolia"
};
var chainNameToChainId = Object.entries(chainNames).reduce((acc, [chainId, chainName]) => {
  return {
    [chainName]: chainId,
    ...acc
  };
}, {});
var defiLlamaChainNames = {
  [56 /* BSC */]: "bsc",
  [1 /* ETHEREUM */]: "ethereum",
  [5 /* GOERLI */]: "",
  [97 /* BSC_TESTNET */]: "",
  [42161 /* ARBITRUM_ONE */]: "arbitrum",
  [421613 /* ARBITRUM_GOERLI */]: "",
  [1101 /* POLYGON_ZKEVM */]: "polygon_zkevm",
  [1442 /* POLYGON_ZKEVM_TESTNET */]: "",
  [324 /* ZKSYNC */]: "era",
  [280 /* ZKSYNC_TESTNET */]: "",
  [59140 /* LINEA_TESTNET */]: "",
  [84531 /* BASE_TESTNET */]: "",
  [204 /* OPBNB */]: "op_bnb",
  [5611 /* OPBNB_TESTNET */]: "",
  [534351 /* SCROLL_SEPOLIA */]: "",
  [59144 /* LINEA */]: "linea",
  [34504 /* ZEUSCHAIN */]: "",
  [62606 /* APOLLO */]: "",
  [33139 /* APECHAIN */]: "apechain",
  [8453 /* BASE */]: "base",
  [137 /* POLYGON */]: "polygon",
  [11155111 /* SEPOLIA */]: "",
  [421614 /* ARBITRUM_SEPOLIA */]: "",
  [84532 /* BASE_SEPOLIA */]: ""
};

// src/utils.ts
function getChainName(chainId) {
  return chainNames[chainId];
}
function getLlamaChainName(chainId) {
  return defiLlamaChainNames[chainId];
}
function getChainIdByChainName(chainName) {
  if (!chainName)
    return void 0;
  return chainNameToChainId[chainName] ?? void 0;
}
function isTestnetChainId(chainId) {
  return testnetChainIds.includes(chainId);
}

// src/subgraphs.ts
var publicSubgraphParams = {
  // Public key for nodereal subgraph endpoint
  noderealApiKey: "19bd2b3f75c24e23bb8a0e9d4f55b271"
};
var V3_SUBGRAPHS = getV3Subgraphs(publicSubgraphParams);
var V2_SUBGRAPHS = getV2Subgraphs(publicSubgraphParams);
var BLOCKS_SUBGRAPHS = getBlocksSubgraphs(publicSubgraphParams);
var STABLESWAP_SUBGRAPHS = {
  [56 /* BSC */]: "",
  [42161 /* ARBITRUM_ONE */]: "https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-stableswap-arb"
};
function getV3Subgraphs({ noderealApiKey, theGraphApiKey = "4f99266a72f0b00ab09ab354492be2d7" }) {
  return {
    [5 /* GOERLI */]: "https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-goerli",
    [97 /* BSC_TESTNET */]: "https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-chapel",
    [42161 /* ARBITRUM_ONE */]: "https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-arb",
    [421613 /* ARBITRUM_GOERLI */]: "https://api.thegraph.com/subgraphs/name/chef-jojo/exhange-v3-arb-goerli",
    [1101 /* POLYGON_ZKEVM */]: `https://gateway-arbitrum.network.thegraph.com/api/${theGraphApiKey}/subgraphs/id/7HroSeAFxfJtYqpbgcfAnNSgkzzcZXZi6c75qLPheKzQ`,
    [1442 /* POLYGON_ZKEVM_TESTNET */]: "",
    [324 /* ZKSYNC */]: "https://api.studio.thegraph.com/query/45376/exchange-v3-zksync/version/latest",
    [280 /* ZKSYNC_TESTNET */]: "https://api.studio.thegraph.com/query/45376/exchange-v3-zksync-testnet/version/latest",
    [59144 /* LINEA */]: "https://api.studio.thegraph.com/query/45376/exchange-v3-linea/version/latest",
    [59140 /* LINEA_TESTNET */]: "https://thegraph.goerli.zkevm.consensys.net/subgraphs/name/pancakeswap/exchange-v3-linea-goerli",
    [34504 /* ZEUSCHAIN */]: "https://graph.zeusx.io/subgraphs/name/v3-node",
    [33139 /* APECHAIN */]: "https://api.goldsky.com/api/public/project_cmrrx7od41rlq01ulcc307k0d/subgraphs/apechain-v3/1.0.0/gn",
    [1 /* ETHEREUM */]: `https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/CmpuuYEZm3QUKGAiLJFGEPzawZB2ycDJCrPcpVHVTh4U`,
    [56 /* BSC */]: `https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/7RK94Lh3k1d1tzygDdoAoyu8QBRhjXc45w9Enx1orvxP`,
    [8453 /* BASE */]: `https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/B8Hv2xJRjjXVkcFMexsHLyEMj2HBgvMby5monJguenrk`,
    [137 /* POLYGON */]: `https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/DrHb5yQ4CEVfyNASpabqgwKqnYLTMb3Lup5BFq7LrLYk`,
    [62606 /* APOLLO */]: "https://graphs.apolloscan.io/subgraphs/name/v3-node",
    [84531 /* BASE_TESTNET */]: "https://api.studio.thegraph.com/query/45376/exchange-v3-base-testnet/version/latest",
    [204 /* OPBNB */]: `https://open-platform-ap.nodereal.io/${noderealApiKey}/opbnb-mainnet-graph-query/subgraphs/name/pancakeswap/exchange-v3`,
    [5611 /* OPBNB_TESTNET */]: "",
    [534351 /* SCROLL_SEPOLIA */]: "https://api.studio.thegraph.com/query/45376/exchange-v3-scroll-sepolia/version/latest",
    [11155111 /* SEPOLIA */]: "",
    [421614 /* ARBITRUM_SEPOLIA */]: "",
    [84532 /* BASE_SEPOLIA */]: ""
  };
}
function getV2Subgraphs({ noderealApiKey, theGraphApiKey = "4f99266a72f0b00ab09ab354492be2d7" }) {
  return {
    [56 /* BSC */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/4eJ14HWgSyjLcX2qbLstFotP9nwfdTbd1HpcnFGjnLDn",
    [1 /* ETHEREUM */]: `https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/B27CPz6keAMQQt2eqE3DxDjnTBW8pRS7wg3S8BprYwbq`,
    [34504 /* ZEUSCHAIN */]: "https://graph.zeusx.io/subgraphs/name/v2-node",
    [33139 /* APECHAIN */]: "https://api.goldsky.com/api/public/project_cmrrx7od41rlq01ulcc307k0d/subgraphs/apechain-v2/1.0.0/gn",
    [8453 /* BASE */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/5UD3sUHAvGi6JT3tDgx1qV4b3NoALGzC2avK5i4yK7Cb",
    [137 /* POLYGON */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/6K3Zb3tcQF1zZaBirxn3qD8hcSVxqS6dT9PJpLYbEdGi",
    [62606 /* APOLLO */]: "https://graphs.apolloscan.io/subgraphs/name/v2-node",
    [1101 /* POLYGON_ZKEVM */]: `https://gateway-arbitrum.network.thegraph.com/api/${theGraphApiKey}/subgraphs/id/37WmH5kBu6QQytRpMwLJMGPRbXvHgpuZsWqswW4Finc2`,
    [280 /* ZKSYNC_TESTNET */]: "https://api.studio.thegraph.com/query/45376/exchange-v2-zksync-testnet/version/latest",
    [324 /* ZKSYNC */]: " https://api.studio.thegraph.com/query/45376/exchange-v2-zksync/version/latest",
    [59140 /* LINEA_TESTNET */]: "https://thegraph.goerli.zkevm.consensys.net/subgraphs/name/pancakeswap/exhange-eth/",
    [42161 /* ARBITRUM_ONE */]: "https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v2-arb",
    [59144 /* LINEA */]: "https://api.studio.thegraph.com/query/45376/exchange-v2-linea/version/latest",
    [204 /* OPBNB */]: `https://open-platform-ap.nodereal.io/${noderealApiKey}/opbnb-mainnet-graph-query/subgraphs/name/pancakeswap/exchange-v2`
  };
}
function getBlocksSubgraphs({ noderealApiKey }) {
  return {
    [56 /* BSC */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/9dSPXfKXaqYpoGAPXx96LyDF1VYR8PiT6HA7HRKEGRdS",
    [1 /* ETHEREUM */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/9A6bkprqEG2XsZUYJ5B2XXp6ymz9fNcn4tVPxMWDztYC",
    [34504 /* ZEUSCHAIN */]: "https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks",
    [33139 /* APECHAIN */]: "https://api.goldsky.com/api/public/project_cmrrx7od41rlq01ulcc307k0d/subgraphs/apechain-blocks/1.0.0/gn",
    [8453 /* BASE */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/GU5jJMiEHpomqddtbsXC3Avj3EweLHk6up1pvy2TCQQZ",
    [137 /* POLYGON */]: "https://gateway.thegraph.com/api/4f99266a72f0b00ab09ab354492be2d7/subgraphs/id/HHpzhtyGrTNSbhtjgZyYG4aG538fKpV21dsCBshLnKDg",
    [62606 /* APOLLO */]: "https://graphs.apolloscan.io/subgraphs/name/blocks",
    [1101 /* POLYGON_ZKEVM */]: "https://api.studio.thegraph.com/query/45376/polygon-zkevm-block/version/latest",
    [324 /* ZKSYNC */]: "https://api.studio.thegraph.com/query/45376/blocks-zksync/version/latest",
    [42161 /* ARBITRUM_ONE */]: "https://api.thegraph.com/subgraphs/name/ianlapham/arbitrum-one-blocks",
    [59144 /* LINEA */]: "https://api.studio.thegraph.com/query/45376/blocks-linea/version/latest",
    [204 /* OPBNB */]: `https://open-platform-ap.nodereal.io/${noderealApiKey}/opbnb-mainnet-graph-query/subgraphs/name/pancakeswap/blocks`
  };
}

export { BLOCKS_SUBGRAPHS, ChainId, STABLESWAP_SUBGRAPHS, V2_SUBGRAPHS, V3_SUBGRAPHS, apeChain, apolloChain, chainNameToChainId, chainNames, defiLlamaChainNames, getBlocksSubgraphs, getChainIdByChainName, getChainName, getLlamaChainName, getV2Subgraphs, getV3Subgraphs, isTestnetChainId, testnetChainIds, zeusChain };
